import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../lib/utils';
export const EmptyBox = (param)=>{
    let { icon, title, className } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('border border-dashed border-white/10 rounded-lg px-6 py-8 flex flex-col gap-4 justify-center items-center', className),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex items-center p-3 border border-white/10 rounded-md",
                children: icon
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "text-lg text-[#FAFAFA] font-medium",
                children: title
            })
        ]
    });
};
